/**
 * @generated SignedSource<<0cf69af8f131a6e53a821adfe453d2fa>>
 * @relayHash 62601fe174804c632501bf3f77818efe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3994f76302fe25ab1b364529fd4ac68aea5137322099097409d6bf003d955a5d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CapacityWorkViewContentQuery } from './CapacityWorkViewContentQuery.graphql';

import isAiImportEnabled_provider from '../../../../../../../platform/packages/capacity-planning/capacity-planning-core/src/ui/capacity-planning-core/table/common/cell/contribution-cell/../../../../../../is-ai-import-enabled.relayprovider';

const node: PreloadableConcreteRequest<CapacityWorkViewContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "3994f76302fe25ab1b364529fd4ac68aea5137322099097409d6bf003d955a5d",
    "metadata": {},
    "name": "CapacityWorkViewContentQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__isaiimportenabledrelayprovidertsx": isAiImportEnabled_provider
    }
  }
};

export default node;
